import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function NotFoundPage() {
  return (
    <>
      <SEO
        title="Siden blev ikke fundet (404)"
        description="Den efterspurgte side kunne desværre ikke findes hos Lunde Media."
      />

      <section className="min-h-[80vh] flex items-center justify-center pt-32 pb-20 px-6">
        <div className="max-w-xl mx-auto text-center space-y-6">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-none bg-[#18181C] border border-[#B89B72]/30 text-[#B89B72] text-2xl font-serif font-bold">
            404
          </div>

          <h1 className="text-3xl sm:text-4xl md:text-5xl font-serif text-[#F4EFEA] tracking-tight">
            Siden blev desværre ikke fundet
          </h1>

          <p className="text-zinc-400 text-sm sm:text-base leading-relaxed">
            Det ser ud til, at siden du leder efter, enten er flyttet, slettet eller aldrig har eksisteret.
          </p>

          <div className="pt-4 flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/"
              className="inline-flex items-center justify-center px-8 py-3.5 rounded-none bg-[#B89B72] hover:bg-[#A68860] text-[#0C0C0D] font-semibold text-sm tracking-wide transition-all shadow-lg"
            >
              Tilbage til forsiden
            </Link>
            <Link
              to="/kontakt"
              className="inline-flex items-center justify-center px-8 py-3.5 rounded-none bg-white/5 hover:bg-white/10 text-white font-medium text-sm tracking-wide transition-all border border-white/10"
            >
              Kontakt Lunde Media
            </Link>
          </div>

          {/* Quick links */}
          <div className="pt-8 border-t border-white/10">
            <div className="text-xs uppercase tracking-wider text-zinc-500 font-medium mb-3">
              Populære sider
            </div>
            <div className="flex flex-wrap justify-center gap-3 text-xs">
              <Link to="/bryllupper" className="text-zinc-400 hover:text-[#B89B72] transition-colors">
                Bryllupper
              </Link>
              <span className="text-zinc-700">·</span>
              <Link to="/cykelloeb" className="text-zinc-400 hover:text-[#B89B72] transition-colors">
                Cykelløb
              </Link>
              <span className="text-zinc-700">·</span>
              <Link to="/events" className="text-zinc-400 hover:text-[#B89B72] transition-colors">
                Events & Erhverv
              </Link>
              <span className="text-zinc-700">·</span>
              <Link to="/familiefotografering" className="text-zinc-400 hover:text-[#B89B72] transition-colors">
                Familiefotografering
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
